import { BASEURL, IMGBASEURL } from "@/config/index";

export default {
    imageBaseURL: BASEURL,
    imageS3BaseURL: !!IMGBASEURL ? IMGBASEURL : "https://img-dev.brij.tech/",
    reportUrl: require("@/config/index").REPORT_URL || BASEURL,
    movieImages: {
        moviesUploadThumbnailImage: "280*350",
    },
    dateFormat: "dd MMM yyyy",
    cookiekeys: {
        BRHSID: 'BRHSID'
    }
}



// WEBPACK FOOTER //
// ./src/helper/constant.js